"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
var _Function = _interopRequireDefault(require("./Function.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var shouldAlternateColors = function shouldAlternateColors(path) {
  return R.filter(R.equals('arguments'), path).length % 2 !== 0;
};
var Function = function Function(_ref) {
  var renderMember = _ref.renderMember,
    keysPath = _ref.keysPath,
    args = _ref.args,
    value = _ref.value,
    separator = _ref.separator,
    disabled = _ref.disabled;
  return /*#__PURE__*/_react["default"].createElement(_Function["default"], {
    className: "formula-group",
    alternate: shouldAlternateColors(keysPath),
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "formula-group-operator"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "formula-operator-label"
  }, (0, _utils.toUpper)(value))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "formula-group-elements"
  }, /* eslint-disable */
  args.map(function (arg, index) {
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: "function-arg-".concat(index)
    }, arg.map(function (item, innerIndex) {
      return renderMember({
        keysPath: [].concat(_toConsumableArray(keysPath), ['arguments', index, innerIndex]),
        member: item,
        key: R.prop('key', item)
      });
    }), index < args.length - 1 && separator());
  })
  /* eslint-enable */));
};
Function.defaultProps = {
  separator: function separator() {
    return /*#__PURE__*/_react["default"].createElement("strong", {
      className: "formula-comma"
    }, ",");
  },
  disabled: false
};
Function.propTypes = {
  disabled: _propTypes["default"].bool,
  value: _propTypes["default"].string.isRequired,
  renderMember: _propTypes["default"].func.isRequired,
  separator: _propTypes["default"].func,
  args: _propTypes["default"].arrayOf(_propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string,
    type: _propTypes["default"].string,
    displayName: _propTypes["default"].string
  }))).isRequired,
  keysPath: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])).isRequired
};
var _default = exports["default"] = Function;